import { createContext, useContext } from "react";
import type { AvailabilityStatus } from "../../api/callsAPI";

/**
 * What the header toggle (and anything else) can read about this browser's
 * call alerts. `active` is false whenever the person cannot take calls or
 * the club has no call routing: every consumer renders nothing then.
 */
export interface CallCenterValue {
  active: boolean;
  /** This tab holds the device. Other tabs of the same browser show status only. */
  isLeader: boolean;
  /** Twilio has this browser registered to ring. */
  registered: boolean;
  /** The person turned call alerts on in this browser. */
  alertsEnabled: boolean;
  deviceError: string | null;
  status: AvailabilityStatus;
  statusSaving: boolean;
  setStatus: (status: AvailabilityStatus) => Promise<void>;
  enableAlerts: () => Promise<void>;
}

export const INERT_CALL_CENTER: CallCenterValue = {
  active: false,
  isLeader: false,
  registered: false,
  alertsEnabled: false,
  deviceError: null,
  status: "off",
  statusSaving: false,
  setStatus: async () => undefined,
  enableAlerts: async () => undefined,
};

export const CallCenterContext = createContext<CallCenterValue>(INERT_CALL_CENTER);

export function useCallCenter(): CallCenterValue {
  return useContext(CallCenterContext);
}
